import { Request } from "~/services";
import { REACT_APP_API_INTEGRATION_ALM_GEN  } from "~/utils";
import { getTenantIdCookie } from "~/utils/tenants";
type GetAzureProjectsResponse = {
  id: string
  name: string
  type: string
}

export async function getAzureProjects(): Promise<GetAzureProjectsResponse[]> {
  const response = await Request(REACT_APP_API_INTEGRATION_ALM_GEN ?? '').get(`/azure/projects/${getTenantIdCookie()}`);

  return response.data;
}